import { jwtDecode } from "jwt-decode";

let logoutTimer;

export const startSessionTimer = () => {
    const token = localStorage.getItem("token");

    if (!token) return;

    try {
        const decoded = jwtDecode(token);

        const expiryTime = decoded.exp * 1000;
        const remainingTime = expiryTime - Date.now();

        if (remainingTime <= 0) {
            logout();
            return;
        }

        clearTimeout(logoutTimer);

        logoutTimer = setTimeout(() => {
            alert("Your session has expired. Please login again.");
            logout();
        }, remainingTime);

    } catch (err) {
        logout();
    }
};

export const logout = () => {

    localStorage.removeItem("token");
    localStorage.removeItem("userEmail");
    localStorage.removeItem("isVerified");
    localStorage.removeItem("journeyId");

    window.location.replace("/home");
};